import About from 'containers/about'

export default About
